module.exports = __webpack_public_path__ + "static/media/completed_coupon_2.5f833249.svg";